import React, { useEffect } from 'react';

import UI from '../ui';
import Utils from '../utils';

const { WrappedButton } = UI;
const { Logger } = Utils;

const SuccessfulVerification = ({ completionCallback }) => {
	useEffect(() => {
		Logger.logToServer({
			verificationStep: 'step3',
			action: 'View',
		});
	});

	const onCloseButtonClick = () => {
		completionCallback(true);
	};

	return (
		<div className="common-account-verification-successful-verification">
			<div className="verification-header-and-image">
				<span className="phone-icon" />
				<div>
					<h1>Verification Successful</h1>
					<p>Your account was successfully verified.</p>
				</div>
			</div>
			<div className="action-bar">
				<WrappedButton
					label="Close"
					onClick={onCloseButtonClick}
					buttonType="primary"
					dataqa="successful-verification-close-button"
				/>
			</div>
		</div>
	);
};

export default SuccessfulVerification;
